const getShippingMethod = (shippingMethod)=>{
    return {
        id: shippingMethod.id,
        key: shippingMethod.key,
        freeAbove: shippingMethod.freeAbove
    };
};

export { getShippingMethod };
//# sourceMappingURL=get-shipping-method.js.map
